/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateTokenReq
 */
export interface ValidateTokenReq {
    /**
     * A JWT token. Can be either a User token (`UserTokenText`) or a Token Container (`TokenContainerText`)
     * @type {string}
     * @memberof ValidateTokenReq
     */
    token: string;
}

/**
 * Check if a given object implements the ValidateTokenReq interface.
 */
export function instanceOfValidateTokenReq(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function ValidateTokenReqFromJSON(json: any): ValidateTokenReq {
    return ValidateTokenReqFromJSONTyped(json, false);
}

export function ValidateTokenReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateTokenReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function ValidateTokenReqToJSON(value?: ValidateTokenReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

